import { filter, isEmpty, split } from 'lodash'

const tokenizeTextByNewLine = text =>
  filter(split(text, '\n'), phrase => !isEmpty(phrase))

export default tokenizeTextByNewLine
